
console.log('MAZING: integration');
// https://cdn.shopify.com/s/files/1/0820/4297/8583/files/mazing-ar-icon.webp?v=1762848732

let currentProduct;
let initializing = false;

const waitForMazingFunction = new Promise((resolve) => {
    const interval = 50;
    const checkInterval = setInterval(() => {
        if (typeof mazing === 'function') {
            clearInterval(checkInterval);
            resolve();
        }
    }, interval);
});

const waitForElement = (selector, timeout = 55000) => {
    return new Promise((resolve) => {
        const interval = 50;
        let elapsedTime = 0;

        const checkInterval = setInterval(() => {
            const element = document.querySelector(selector);
            if (element) {
                clearInterval(checkInterval);
                resolve(element);
            } else if ((elapsedTime += interval) >= timeout) {
                clearInterval(checkInterval);
                resolve();
            }
        }, interval);
    });
};


const initializeMazing = async () => {
    await mazing({
        customerName: 'BLOKDEK',
        buttonConfiguration: {
            customStyle: `
                .mazing-button-container {
                    position: absolute;
                    bottom: 0;
                    left: 50%;
                    transform: translateX(-50%);
                    justify-content: start;
                    z-index: 6;
                }
                
                .mazing-ar-btn-icon,
                .mazing-threed-btn-icon {
                    filter: invert(100%) sepia(0%) saturate(0%) hue-rotate(0deg) brightness(100%) contrast(100%);
                    transition: filter .2s linear;
                    width: auto !important;
                    margin: 0 !important;
                }
                
                .mazing-threed-btn,
                .mazing-ar-btn {
                    background: #37595a !important;        
                    box-shadow: none !important;
                    border: solid 1px #37595a;
                    border-radius: 16px !important;
                    transition: all .2s linear;
                    color: #fff;
                    display: flex;
                    justify-content: space-around; 
                    gap: 10px;
                    padding-left: 24px;
                    border-radius: 5px;
                    padding-right: 24px;
                    position: relative;
                    overflow: hidden;
                    z-index: 1;
                }
                
                .mazing-threed-btn:hover,
                .mazing-ar-btn:hover {
                    color: #37595a !important;
                    background: #fff !important;
                    opacity: 1;
                }
                
                .mazing-threed-btn:hover img,
                .mazing-ar-btn:hover img{
                    transition: filter .2s linear;
                    filter: invert(30%) sepia(17%) saturate(879%) hue-rotate(133deg) brightness(94%) contrast(86%);
                }
                
                .mazing-threed-btn-text,
                .mazing-ar-btn-text{
                    font-weight: 700;
                    color: inherit;
                    text-wrap-mode: nowrap;
                    font-family: Satoshi !important;
                    font-weight: 700;
                    letter-spacing: 0.1rem;
                }
                
                .mazing-threed-btn::before,
                .mazing-ar-btn::before {
                    content: "";
                    position: absolute;
                    top: 0;
                    left: 0;
                    height: 100%;
                    width: 100%;
                    background: rgba(255, 255, 255, 0.15);
                    transform: scaleX(0);
                    transform-origin: left;
                    transition: transform 0.3s ease;
                    z-index: -1;
                }
                
                .mazing-threed-btn:hover::before,
                .mazing-ar-btn:hover::before {
                    color: #37595a !important;
                    background-color: #fff !important;
                }
                
                @media (max-width: 500px) {
                    
                   .mazing-button-container {
                    bottom: 30px;
                   }
                    
                   .mazing-ar-btn-text,
                   .mazing-threed-btn-text {
                    font-size: 14px;
                   }
                   
                   .mazing-threed-btn,
                   .mazing-ar-btn {
                    border-radius: 6px !important;
                   }
                }
            `,
                placementSelector: (() => {
                        return ".slider-mobile-gutter";
            })(),
            threedBtn: {
                enabled: false,
                icon: true,
                customText: (() => {
                    const lang = navigator.language || navigator.userLanguage;
                    const translations = {
                        "en": "View in 3D",
                        "de": "In 3D ansehen",
                        "fr": "Voir en 3D",
                        "es": "Ver en 3D"
                    };

                    return translations[lang.split("-")[0]] || translations["en"];
                })()
            },
            arBtn: {
                enabled: true,
                icon: false,
                customText: (() => {
                    const lang = navigator.language || navigator.userLanguage;
                    const translations = {
                        "en": "See It In Your Space",
                        "de": "In Ihrem Garten anzeigen",
                        "fr": "Voir chez vous",
                        "es": "Ver en tu espacio"
                    };

                    return translations[lang.split("-")[0]] || translations["en"];
                })()
            }
        },
        getSKU: getCurrentSKU
    });

    console.log('Mazing initialized.');
};

// A/B SECTION removed


//example (${url}-${length}x${width}) natural-cedar-deck-6x10
const getCurrentSKU = () => {
    const url = window.location.href;
    const parts = url.split("/");
    const product = parts.filter(part => part.trim() !== '' && !part.trim().startsWith("?")).pop();
    const productParts = product.split('?');

    currentProduct = `${productParts[0]}`;

    const lengthSelectionElement = document.querySelectorAll('select[name="options[Length]"]')[0];
    const widthSelectionElement = document.querySelectorAll('select[name="options[Width]"]')[0];


    function attachOptionChangeListeners(optionInputs) {
        if (!optionInputs[0]) return;
        if (optionInputs[0].dataset.listenerAttached === 'true') return;

        optionInputs.forEach(input => {
            input.addEventListener("change", async () => {
                setTimeout(() => mazingRefreshSKU(getCurrentSKU(), 'BLOKDEK'), 100)
            });
        });

        optionInputs[0].dataset.listenerAttached = 'true';
    }

    if (lengthSelectionElement && widthSelectionElement) {
        const selectedLength = lengthSelectionElement.value || lengthSelectionElement.options[0].value;
        const selectedWidth = widthSelectionElement.value || widthSelectionElement.options[0].value;
        if (selectedLength && selectedWidth) {
            currentProduct += `-${selectedLength.trim()}x${selectedWidth.trim()}`;
        }
        const optionInputs = [lengthSelectionElement, widthSelectionElement];
        attachOptionChangeListeners(optionInputs);
    }
    console.log('Final SKU:', currentProduct.toLowerCase());
    return currentProduct.toLowerCase();
};


const addCustomIconToMazingButton = () => {
    const arButton = document.querySelector('.mazing-ar-btn');

    if (arButton) {
        const existingIcon = arButton.querySelector('.mazing-ar-btn-icon');
        if (!existingIcon) {
            const iconImg = document.createElement('img');
            iconImg.src = "https://cdn.shopify.com/s/files/1/0820/4297/8583/files/mazing-ar-icon.webp?v=1762848732";
            iconImg.alt = "View in Room";
            iconImg.classList.add("mazing-ar-btn-icon");
            iconImg.style.height = "36px";
            iconImg.style.marginLeft = "10px";

            arButton.prepend(iconImg);
        }
    }
};

const initializeScript = async () => {
    if (initializing) return;
    initializing = true;

    try {
        await waitForMazingFunction;
        console.log('mazingProjectAvailable is now available');

        document.querySelectorAll('.mazing-button-container').forEach(btn => btn.remove());
        document.querySelectorAll('#mazing-popup-container').forEach(popup => popup.remove());

        await initializeMazing();
        addCustomIconToMazingButton();

        // document.getElementById('mazing-popup-container').style.zIndex = '99999999';
        // document.querySelector('.shopify-section.shopify-section-group-header-group.cc-header').style.zIndex = '999999999';

        console.log('Initialized successfully.');
    } catch (error) {
        console.error('Initialization failed:', error);
    } finally {
        initializing = false;
    }
};

initializeScript();
